import React from 'react';
import { howItWorks } from '../mock';
import { FileText, MagnifyingGlass, CheckCircle } from '@phosphor-icons/react';
import useEmblaCarousel from 'embla-carousel-react';

const iconMap = {
  FileText: FileText,
  CreditCard: MagnifyingGlass,
  CheckCircle: CheckCircle
};

const HowItWorksSection = () => {
  const [emblaRef] = useEmblaCarousel({ loop: true, align: 'start' });

  return (
    <section data-testid="how-it-works-section" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#D4AF37] mb-3">
            The Process
          </p>
          <h2 className="text-3xl sm:text-4xl font-heading font-medium text-white tracking-tight mb-4">
            Three Steps to Federal Protection
          </h2>
          <p className="text-base text-slate-400 max-w-2xl mx-auto leading-relaxed">
            From consultation to registration, our attorneys handle the complexity while you focus on growing your business.
          </p>
        </div>

        {/* Grid for desktop, slider for mobile */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-xs:hidden">
          {howItWorks.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={step.id} data-testid={`step-${index + 1}`} className="relative group text-center">
                <div className="w-16 h-16 bg-[#044B3B] rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="h-7 w-7 text-white" weight="regular" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-white mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
                {/* Connector Line */}
                {index < howItWorks.length - 1 && (
                  <div className="hidden md:block absolute top-8 right-0 translate-x-1/2 w-16 h-[2px] bg-gradient-to-r from-[#044B3B] to-transparent"></div>
                )}
              </div>
            );
          })}
        </div>

        {/* Slider for mobile (576px and below) */}
        <div className="overflow-hidden xs:hidden" ref={emblaRef}>
          <div className="flex gap-4">
            {howItWorks.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div key={step.id} data-testid={`step-${index + 1}`} className="flex-[0_0_85%] group text-center">
                  <div className="w-16 h-16 bg-[#044B3B] rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="h-7 w-7 text-white" weight="regular" />
                  </div>
                  <h3 className="text-xl font-heading font-semibold text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm text-slate-400 leading-relaxed max-w-xs mx-auto">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
